/* Combo trio — mobile infinite swipe (both directions, native momentum).
   Track = [clones][originals][clones]; when you settle in a clone set we
   silently jump to the matching original, so the loop never ends. */
(function () {
  var mq = matchMedia("(max-width: 900px)");
  [].slice.call(document.querySelectorAll(".nn-combo-row")).forEach(function (row) {
    var originals = [].slice.call(row.children);
    var n = originals.length;
    if (n < 2) return;
    var built = false, dots, timer, jumping = false;

    function cloneSet() {
      return originals.map(function (el) {
        var c = el.cloneNode(true);
        c.classList.add("is-clone");
        c.setAttribute("aria-hidden", "true");
        c.removeAttribute("data-shopify-editor-block");
        [].slice.call(c.querySelectorAll("a,button")).forEach(function (a) { a.tabIndex = -1; });
        return c;
      });
    }

    function step() {
      var a = row.children[0], b = row.children[1];
      return b.offsetLeft - a.offsetLeft;
    }
    function setWidth() { return step() * n; }
    function index() {
      var mid = row.scrollLeft + row.clientWidth / 2, best = 0, d = 1e9;
      for (var i = 0; i < row.children.length; i++) {
        var c = row.children[i], m = c.offsetLeft + c.offsetWidth / 2, dd = Math.abs(m - mid);
        if (dd < d) { d = dd; best = i; }
      }
      return best;
    }
    function center(i, smooth) {
      var c = row.children[i];
      var left = c.offsetLeft - (row.clientWidth - c.offsetWidth) / 2;
      if (smooth) row.scrollTo({ left: left, behavior: "smooth" });
      else row.scrollLeft = left;
    }
    function paint() {
      var i = index();
      for (var k = 0; k < row.children.length; k++) row.children[k].classList.toggle("is-on", k === i);
      if (dots) for (var d = 0; d < n; d++) dots.children[d].classList.toggle("is-on", d === i % n);
    }
    function settle() {
      var i = index();
      if (i < n || i >= 2 * n) {
        jumping = true;
        row.style.scrollSnapType = "none";
        row.scrollLeft += (i < n ? 1 : -1) * setWidth();
        row.offsetHeight;
        row.style.scrollSnapType = "";
        jumping = false;
      }
      paint();
    }

    function build() {
      if (built) return;
      built = true;
      var before = cloneSet(), after = cloneSet();
      before.forEach(function (c) { row.insertBefore(c, originals[0]); });
      after.forEach(function (c) { row.appendChild(c); });
      row.classList.add("is-loop");
      dots = document.createElement("div");
      dots.className = "nn-combo-dots";
      for (var d = 0; d < n; d++) {
        var b = document.createElement("button");
        b.type = "button";
        b.setAttribute("aria-label", "Show item " + (d + 1));
        (function (d) { b.addEventListener("click", function () { center(n + d, true); }); })(d);
        dots.appendChild(b);
      }
      row.after(dots);
      requestAnimationFrame(function () { center(n, false); paint(); });
    }
    function teardown() {
      if (!built) return;
      built = false;
      [].slice.call(row.querySelectorAll(".is-clone")).forEach(function (c) { c.remove(); });
      row.classList.remove("is-loop");
      if (dots) dots.remove();
      dots = null;
      row.scrollLeft = 0;
    }
    function apply() { mq.matches ? build() : teardown(); }

    row.addEventListener("scroll", function () {
      if (!built || jumping) return;
      paint();
      clearTimeout(timer);
      timer = setTimeout(settle, 130);
    }, { passive: true });
    if ("onscrollend" in window) row.addEventListener("scrollend", function () { if (built) { clearTimeout(timer); settle(); } });

    addEventListener("resize", function () { if (built) center(n + (index() % n), false); }, { passive: true });
    if (mq.addEventListener) mq.addEventListener("change", apply); else mq.addListener(apply);
    apply();
  });
})();
